import { render, staticRenderFns } from "./RecipeSlide.vue?vue&type=template&id=fe599fea&"
import script from "./RecipeSlide.vue?vue&type=script&lang=js&"
export * from "./RecipeSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports